module.exports = __webpack_public_path__ + "media/jobs_page/heroimg_statejobs_desktop-7b31abd0.jpg";